export const LOGGED_OUT_CAT_PAGE_SIZE = 57; // 60 - 3 (banners)
